import PropTypes from 'prop-types';
import CertificationNumber from './CertificationNumber';

const defaultProps = {};

const propTypes = {
  minimumApprovalLevel: PropTypes.number.isRequired,
  examCompletionTimeLimit: PropTypes.number.isRequired,
  numberOfExamQuestions: PropTypes.number.isRequired,
};

export default function CertificationNumbers({
  minimumApprovalLevel,
  examCompletionTimeLimit,
  numberOfExamQuestions,
}) {
  if (minimumApprovalLevel === null
    && examCompletionTimeLimit === null
    && numberOfExamQuestions === null) {
    return null;
  }

  return (
    <div className="flex-1 flex-col font-mono space-y-1">
      {minimumApprovalLevel && <CertificationNumber label="Nivel mínimo" value={`${minimumApprovalLevel}%`} />}
      {examCompletionTimeLimit && <CertificationNumber label="Tiempo límite" value={`${examCompletionTimeLimit} minutos`} />}
      {numberOfExamQuestions && <CertificationNumber label="Preguntas" value={numberOfExamQuestions} />}
    </div>
  );
}

CertificationNumbers.defaultProps = defaultProps;
CertificationNumbers.propTypes = propTypes;
